import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './onvio-loader2.js';

const onvioProgressBarCss = ".SD-overlay{background-color:#fff;height:100vh;left:0;opacity:0.7;position:fixed;top:0;width:100vw;z-index:1040}.SD-modal{background:transparent;display:flex;flex-direction:column;justify-content:space-between;left:50%;position:fixed;top:50%;z-index:1050}.SD-progress-container{align-items:center;color:black;display:flex;flex-direction:column;font-family:\"Source Sans Pro\", arial, sans-serif;font-size:16px;font-style:normal;height:inherit;justify-content:center;line-height:20px;padding-top:12px}.SD-progress-label{color:#1f1f1f;font-weight:600}";

const OnvioProgressBar$1 = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.loading = false;
    this.progress = undefined;
    this.working = undefined;
    this.complete = undefined;
    this.size = '40px';
    this.color = '#fa6400ff';
    this.loadingText = undefined;
    this.displayLoader = false;
  }
  someProgress(value) {
    return (value > -1 && (h("label", { class: "SD-progress-label" }, this.progress, "% ", this.complete)));
  }
  onvioLoader(display) {
    return (display && (h("onvio-loader", { loading: this.loading, size: this.size, color: this.color, loadingText: this.loadingText, class: "SD-preview-loader" })));
  }
  render() {
    return (this.loading && (h(Host, null, h("slot", null, h("div", { class: "SD-overlay" }), h("div", { class: "SD-modal" }, this.onvioLoader(this.displayLoader), h("div", { class: "SD-progress-container" }, h("label", { class: "SD-progress-label" }, this.working, " ... "), this.someProgress(this.progress)))))));
  }
  static get style() { return onvioProgressBarCss; }
}, [1, "onvio-progress-bar", {
    "loading": [4],
    "progress": [2],
    "working": [1],
    "complete": [1],
    "size": [1],
    "color": [1],
    "loadingText": [1, "loading-text"],
    "displayLoader": [4, "display-loader"]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["onvio-progress-bar", "onvio-loader"];
  components.forEach(tagName => { switch (tagName) {
    case "onvio-progress-bar":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, OnvioProgressBar$1);
      }
      break;
    case "onvio-loader":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const OnvioProgressBar = OnvioProgressBar$1;
const defineCustomElement = defineCustomElement$1;

export { OnvioProgressBar, defineCustomElement };

